<template>
	<v-dialog
		v-model="show"
		max-width="600"
	>
		<template #activator="{ on }">
			<v-btn
				elevation="0"
				small
				icon
				v-on="on"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</template>

		<v-card>
			<v-card-title>Добавление машины</v-card-title>
			<v-card-text>
				<v-form @submit.stop.prevent="submit">
					<v-text-field
						v-model="form.model_name"
						name="name"
						label="Название"
						outlined
						dense
					/>
					<v-btn
						type="submit"
						color="green"
						outlined
					>
						Сохранить
					</v-btn>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
const EMPTY_FORM = () => ({
	model_name: '',
});

export default {
	name: 'CreateMachineModal',
	props: {
		vendorId: Number,
	},
	data: () => ({
		show: false,
		loading: false,
		form: EMPTY_FORM(),
	}),
	methods: {
		async submit() {
			if (this.loading) return;
			this.loading = true;
			try {
				const form = Object.assign({
					vendor_id: this.vendorId,
				}, this.form);
				await this.$http.post('/api/v2/schemes/machines', form);
				this.$notify('Машина добавлена');
				this.$emit('created');
				this.show = false;
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped>

</style>
